import React from 'react'

function WomanScooter() {
  return (
    <svg width={263} height={254} viewBox="0 0 263 254" fill="none">
      <path
        d="M250.256 30.856c21.411 27.93 12.904 78.562-3.943 117.175-16.945 38.539-42.255 65.131-75.081 83.799-32.826 18.667-73.094 29.561-103.653 16.337-30.558-13.225-51.26-50.422-61.324-91.011-10.07-40.663-9.365-84.65 12.406-112.726C40.43 16.353 83.228 4.264 130.397.87c47.06-3.304 98.458 1.977 119.859 29.985z"
        fill="#F3F5F8"
      />
      <path
        d="M232.065 208.25L205.356 79.658"
        stroke="#D8D8D8"
        strokeWidth={4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M159.285 86.289c2.665 2.557 8.452 11.548 11.174 11.548 7.55 0 30.665-14.105 32.248-17.983.4-1.062-2.321-3.776-3.076-3.776-.756 0-14.229 8.053-22.501 7.305-4.507-.404-7.494-9.356-12.362-14.554M18.204 96.443c-.563-.63-3.561-4.496-4.637-4.642-1.939-.292-9.332 6.969-9.388 7.654-.056.686.394 1.641.913 1.579.518-.062 4.18-2.118 4.863-2.186.681-.067 2.597.978 3.099 2.006"
        fill="#1F161E"
      />
      <path
        d="M160.851 100.748c2.361 2.157 26.777 48.553 26.777 54.509 0 5.957-19.598 50.616-21.238 51.571-1.64.956-6.48.191-7.714-1.152s6.198-49.272 6.198-49.272l-36.288-37.191 32.265-18.465z"
        fill="#C01414"
      />
      <path
        d="M131.843 82.917c-2.643 1.557-40.723 23.006-51.165 32.672-5.668-1.483-61.752-20.972-62.496-20.528-.744.444-6.266 4.687-6.266 5.687s57.549 46.974 73.073 46.974c5.669 0 60.107-31.768 75.846-46.974 1.589-8.514-21.678-22.147-28.992-17.831z"
        fill="#D62929"
      />
      <path
        d="M156.282 51.706c-5.731-2.018-24.388 29.783-24.388 31.21 0 1.428 26.349 18.023 29.014 17.832 2.665-.191 22.387-39.529-4.626-49.042z"
        fill="#4D4D4D"
      />
      <path
        d="M174.583 39.792c.772-.067 3.336-3.253 1.967-10.379-1.657-2.163-7.145-2.849-7.326-.399-.18 2.45 3.004 10.998 5.359 10.778z"
        fill="#1F161E"
      />
      <path
        d="M163.089 59.393c-.192 1.41-7.979.45-7.771-1.062l1.296-9.418 7.771 1.062-1.296 9.418z"
        fill="#B3B3B3"
      />
      <path
        d="M155.842 54.539c.113-.837 2.434-3.462 3.848-2.776-1.741-.894-2.344-3.209-3.076-2.85l-.772 5.626z"
        fill="#000"
      />
      <path
        d="M164.897 53.19c-5.626 0-10.188-4.55-10.188-10.16 0-5.612 4.562-10.16 10.188-10.16 5.627 0 10.188 4.548 10.188 10.16 0 5.61-4.561 10.16-10.188 10.16z"
        fill="#B3B3B3"
      />
      <path
        d="M161.195 21.135c-13.484 0-23.165 2.209-29.47 2.209-9.709 0-17.373-4.344-28.259-4.344-4.959 0-17.654 4.203-17.654 18.432 0 8.064 4.508 24.08 23.818 24.08 16.533 0 19.412-6.974 26.118-6.974 7.066 0 20.207 3.321 22.421-5.664.485-2.389 1.026-5.317 2.35-7.722 7.376-2.568 9.771-2.343 13.259-4.4 5.037-2.388 5.28-15.617-12.583-15.617z"
        fill="#1F161E"
      />
      <path
        d="M158.676 44.9a2.24 2.24 0 01-2.242-2.236 2.24 2.24 0 012.242-2.237 2.24 2.24 0 012.243 2.237 2.24 2.24 0 01-2.243 2.236z"
        fill="#B3B3B3"
      />
      <path
        d="M159.195 205.406c-.18.81-1.465 5.53-.952 6.485.93 1.72 11.191 3.282 11.765 2.911.575-.371 1.088-1.292.727-1.686-.36-.393-4.203-2.079-4.665-2.573-.462-.495-.772-2.67-.248-3.681"
        fill="#1F161E"
      />
      <path
        d="M220.688 219.293H115.936"
        stroke="#D8D8D8"
        strokeWidth={4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M206.145 78.652l-7.624-4.878"
        stroke="#969696"
        strokeWidth={4}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M203.699 79.343c-2.371 0-4.293-1.092-4.293-2.439 0-1.346 1.922-2.438 4.293-2.438 2.372 0 4.294 1.092 4.294 2.439 0 1.346-1.922 2.438-4.294 2.438z"
        fill="#B3B3B3"
      />
      <path
        d="M207.04 82.097c-2.371 0-4.294-1.092-4.294-2.44 0-1.346 1.923-2.438 4.294-2.438 2.372 0 4.294 1.092 4.294 2.439s-1.922 2.439-4.294 2.439z"
        fill="#B3B3B3"
      />
      <path
        d="M214.31 83.872l-5.754-3.68"
        stroke="#969696"
        strokeWidth={4}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M156.434 86.957c2.665 2.552 13.924 13.133 16.634 13.133 7.551 0 30.659-14.105 32.249-17.982.4-1.063-2.322-3.777-3.077-3.777-.755 0-17.232 8.666-25.504 7.901-4.507-.404-13.219-16.184-18.088-21.388"
        fill="#4D4D4D"
      />
      <path
        d="M232.854 231.51c-6.719 0-12.166-5.432-12.166-12.133 0-6.701 5.447-12.133 12.166-12.133s12.166 5.432 12.166 12.133c0 6.701-5.447 12.133-12.166 12.133zM103.77 231.51c-6.72 0-12.166-5.432-12.166-12.133 0-6.701 5.447-12.133 12.166-12.133s12.166 5.432 12.166 12.133c0 6.701-5.447 12.133-12.166 12.133z"
        stroke="#969696"
        strokeWidth={4}
        strokeMiterlimit={10}
      />
      <path
        d="M170.002 79.888c-2.04-2.664-4.356-6.035-6.334-8.856M156.433 86.957c1.336 1.276 4.812 4.558 8.3 7.525"
        stroke="#1F161E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M159.539 90.228c.76.691 4.688 6.255 3.544 7.946 1.46-2.68 1.865-3.512 1.865-3.512"
        fill="#1F161E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M169.536 43.694a.344.344 0 00-.148.465c.026.05.059.11.097.177.172.313.439.796.547 1.285.064.292.059.535-.023.719-.074.166-.235.339-.613.447a.345.345 0 10.191.663c.53-.152.879-.44 1.053-.83.166-.374.145-.786.065-1.148-.133-.602-.468-1.203-.633-1.5l-.071-.13a.345.345 0 00-.465-.148zM166.327 47.697a.346.346 0 00-.139.467c.187.346.468.71.77 1 .291.28.655.544 1.015.604a.345.345 0 00.114-.681c-.147-.024-.383-.163-.65-.42a3.577 3.577 0 01-.642-.831.345.345 0 00-.468-.14z"
        fill="#1F161E"
      />
      <ellipse cx={172.992} cy={44} rx={0.5} ry={1} fill="#0D0D0D" />
      <ellipse cx={164.992} cy={43} rx={0.5} ry={1} fill="#0D0D0D" />
      <path
        d="M163 48c1.105 0 2-.448 2-1s-.895-1-2-1-2 .448-2 1 .895 1 2 1z"
        fill="#FA9E9F"
      />
    </svg>
  )
}

export default React.memo(WomanScooter)
